var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 10.583L6.66602 6.74967L7.83268 5.58301L12.8327 10.583L7.83268 15.583L6.66602 14.4163L10.4993 10.583Z",
    fill: "white"
  })));
}

export default __webpack_public_path__ + "media/8dfbf3c6.svg";
export { SvgArrowRight as ReactComponent };